import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    student_id: '',
  },
}

export const ledgerUI = createSlice({
  name: 'ledgerUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setStudentId: (state, { payload }) => {
      state.tableFilters.student_id = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const { setSearch, setStudentId, trackActiveFilters, clearAllFilters } = ledgerUI.actions

export default ledgerUI.reducer
